import React, { type FC } from "react";
import type { NestTestResultError } from "src/api/interfaces/nest/history";
import type { DataTableCellChildComponentProps } from "src/components/DataTable/DataTableDefinition";

const NestErrorElementCell: FC<
  DataTableCellChildComponentProps<NestTestResultError>
> = ({ content }) => {
  return <>{content.element?.split("/").pop()}</>;
};

export default NestErrorElementCell;
